import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"

const OuraSyncExplanationInstructions: InstructionComponentProps = {
    name: "Warum muss ich die Oura App öffnen um die Ring-Daten zu erhalten?",
    path: "/help/patient/oura_sync_explanation",
    description:
        "Die DOOR Studie Connect App benötigt die Oura App, um die Daten vom Oura-Ring zu erhalten. Hier erfahren Sie, warum dieser Schritt notwendig ist.",
    both: [
        <ImageTextComponent
            text={
                <>
                    <strong>Wie funktioniert die Datenübertragung?</strong>
                    <br /><br />
                    Der Oura-Ring sammelt kontinuierlich Daten über Ihren Schlaf, Ihre Herzfrequenz und andere Gesundheitsparameter. 
                    Diese Daten werden jedoch nicht automatisch an andere Apps weitergegeben.
                </>
            }
            images={[]}
        />,
        <ImageTextComponent
            text={
                <>
                    <strong>Die Rolle der Oura App:</strong>
                    <br /><br />
                    Die Oura App fungiert als "Vermittler" zwischen Ihrem Ring und anderen Anwendungen. 
                    Wenn Sie die Oura App öffnen, wird eine Verbindung zum Ring hergestellt und alle gesammelten Daten 
                    werden synchronisiert und für andere Apps verfügbar gemacht.
                </>
            }
            images={[]}
        />,
        <ImageTextComponent
            text={
                <>
                    <strong>Warum ist die Synchronisation notwendig?</strong>
                    <br /><br />
                    Die DOOR Studie Connect App kann nur auf Daten zugreifen, die bereits über die Oura App synchronisiert wurden. 
                    Ohne die Synchronisation über die Oura App bleiben die Daten nur lokal auf dem Ring gespeichert 
                    und sind für die DOOR Studie nicht verfügbar.
                </>
            }
            images={[]}
        />,
        <ImageTextComponent
            text={
                <>
                    <strong>Der Synchronisationsprozess:</strong>
                    <br /><br />
                    1. Ring sammelt Daten → 2. Oura App öffnen → 3. Daten werden synchronisiert → 4. DOOR Studie Connect App kann auf Daten zugreifen
                    <br /><br />
                    Deshalb ist es wichtig, regelmäßig die Oura App zu öffnen, um sicherzustellen, dass alle Ihre Gesundheitsdaten 
                    für die Studie verfügbar sind.
                </>
            }
            images={[]}
        />
    ]
}

export default OuraSyncExplanationInstructions 